import axios from 'axios';

class IpService {
    async getIp() {
        let ip;
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            ip = response.data.ip;
        } catch (e) {
            //do nothing
        }
        return ip;
    };
}

export default new IpService();